import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFoundPage = () => {
  return (
    <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center flex-1 p-4 relative z-10 gap-2 min-h-screen">
      <Helmet>
        <title>404 - Sayfa Bulunamadı</title>
        <meta
          name="description"
          content="Aradığınız sayfa bulunamadı. Ana sayfaya dönerek diğer içeriklere göz atabilirsiniz."
        />
      </Helmet>
      {/* Sol Panel: Görsel400 */}
      <div className="flex w-full sm:w-1/2 mb-6 justify-center">
        <img
          src="/illustrations404.svg"
          alt="404 Hata Sayfası"
          className="w-full h-auto max-w-[200px] sm:max-w-[300px] md:max-w-[350px]"
        />
      </div>
      {/* Sağ Panel: Metin ve Butonlar */}
      <div className="flex w-full sm:w-1/2">
        <div className="flex flex-col gap-4 sm:gap-8">
          {/* Metinler */}
          <div className="flex flex-col text-left gap-4 sm:gap-8">
            <img
              src="/404.svg" // Görsel dosyanı buraya ekle
              alt="404 Illustration"
              className="w-[200px] h-[80px] md:w-[310px] md:h-[120px] sm:w-[250px] sm:h-[100px]"
            />
            <div className="flex flex-col gap-2 items-start">
              <p className="text-lg font-semibold text-grayy">
                Sayfa Bulunamadı
              </p>
            </div>
          </div>
          {/* Butonlar */}
          <div className="flex gap-4">
            <Link to="/" className="btn-dark text-white text-xs">
              Ana sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
